import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const CheckboxRow = ({ label, checked, onToggle, accessory, disabled = false }) => {
  const { palette } = useTheme();
  return (
    <TouchableOpacity 
      style={[styles.row, disabled && { opacity: 0.5 }]} 
      onPress={onToggle} 
      activeOpacity={0.8}
      disabled={disabled}
    >
      <View style={[styles.checkbox, { borderColor: '#F1F1F1' }]}>
        {checked ? <View style={[styles.checkboxInner, { backgroundColor: '#F1F1F1' }]} /> : null}
      </View>
      {typeof label === 'string' ? <Text style={[styles.label, { color: '#F1F1F1' }]}>{label}</Text> : label}
      {accessory ? <View style={styles.accessory}>{accessory}</View> : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
  },
  checkbox: {
    width: 14,
    height: 14,
    borderWidth: 1,
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',
            ...Platform.select({
            web: {
                boxShadow: '1px 1px 0px rgba(0,0,0,1)',
            },
            default: {
                shadowColor: '#000000',
                shadowOffset: { width: 5, height: 7 },
                shadowOpacity: 1,
                shadowRadius: 0,
                elevation: 8,
            },
        }),
  },
  checkboxInner: {
    width: 12,
    height: 12,
    borderRadius: 2,
  },
  label: {
    fontSize: 13,
    fontFamily: 'Chivo',
    fontWeight: '500',
    lineHeight: 16,
     ...Platform.select({
                web: {
                    textShadow: '2px 2px 1px rgba(0,0,0,1)',
                },
                default: {
                    textShadowColor: 'rgba(0,0,0,1)',
                    textShadowOffset: { width: 2, height: 2 },
                    textShadowRadius: 1,
                },
            }),
  },
  accessory: {
    marginLeft: 8,
  },
});

export default CheckboxRow;


